import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import {applyGroupSelectionDimming} from "./Cyto/groupSelectionDim";

export default connect(
    state => ({open: state.getIn(['ui', 'group_add', 'open'])}),
    dispatch => ({close:()=>{
        dispatch({type: 'GROUP_ADD_CLOSE'})
    }})
)(props => {
    // [#137] 그룹에 지식 추가 모드에서는 후보 노드를 가리지 않도록 엣지는 완전히 숨기고,
    // 노드는 항상 선명하게 유지한다. 모드 종료 시 원래대로 되돌린다.
    useEffect(() => {
        applyGroupSelectionDimming(props.open);
    }, [props.open]);

    return (
        <Snackbar open={props.open}>
        <Alert severity="success" onClose={props.close}>
          여기에 포함될 지식을 선택해주세요
        </Alert>
      </Snackbar>
    );
})
